import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeProcessStepSkeleton } from "./TypeProcessStep";
import type { TypeTableOfContentsSettingSkeleton } from "./TypeTableOfContentsSetting";

/**
 * Fields type definition for content type 'TypeProcessStepsSection'
 * @name TypeProcessStepsSectionFields
 * @type {TypeProcessStepsSectionFields}
 * @memberof TypeProcessStepsSection
 */
export interface TypeProcessStepsSectionFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'header' (Header)
     * @name Header
     * @localized true
     */
    header?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'subHeader' (Sub Header)
     * @name Sub Header
     * @localized true
     */
    subHeader?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'description' (Description)
     * @name Description
     * @localized true
     */
    description?: EntryFieldTypes.Text;
    /**
     * Field type definition for field 'steps' (Steps)
     * @name Steps
     * @localized false
     */
    steps: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeProcessStepSkeleton>>;
    /**
     * Field type definition for field 'backgroundColor' (Background Color)
     * @name Background Color
     * @localized false
     */
    backgroundColor: EntryFieldTypes.Symbol<"grey" | "light-blue" | "white">;
    /**
     * Field type definition for field 'backToTopCta' (Back to top CTA)
     * @name Back to top CTA
     * @localized false
     */
    backToTopCta?: EntryFieldTypes.Boolean;
    /**
     * Field type definition for field 'tocSetting' (tocSetting)
     * @name tocSetting
     * @localized false
     */
    tocSetting?: EntryFieldTypes.EntryLink<TypeTableOfContentsSettingSkeleton>;
}

/**
 * Entry skeleton type definition for content type 'processStepsSection' (Process Steps Section)
 * @name TypeProcessStepsSectionSkeleton
 * @type {TypeProcessStepsSectionSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T13:18:59.262Z
 * @version 23
 */
export type TypeProcessStepsSectionSkeleton = EntrySkeletonType<TypeProcessStepsSectionFields, "processStepsSection">;
/**
 * Entry type definition for content type 'processStepsSection' (Process Steps Section)
 * @name TypeProcessStepsSection
 * @type {TypeProcessStepsSection}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T13:18:59.262Z
 * @version 23
 */
export type TypeProcessStepsSection<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeProcessStepsSectionSkeleton, Modifiers, Locales>;

export function isTypeProcessStepsSection<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeProcessStepsSection<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'processStepsSection'
}
